module.exports = __webpack_public_path__ + "img/ura.811f624b.png";